import type * as React from 'react';
import { UIText1, ArticleParagraph1, ArticleParagraph3 } from '@cian/ui-kit';
import {
  IconProductWarning16,
  IconProductTrust16,
  IconProductEscrou16,
  IconProductSalesStart16,
} from '@cian/ui-kit-design-tokens/icons';
import * as styles from './styles.css';

export interface IHouseSelectItemProps {
  title: string;
  subtitle?: string;
  value?: string | number | null;
  isReliable?: boolean;
  hasProblems?: boolean;
  isEscrow?: boolean;
  isSalesStart?: boolean;
}

export function HouseSelectItem({
  title,
  subtitle,
  value,
  isEscrow = false,
  isReliable = false,
  hasProblems = false,
  isSalesStart = false,
}: IHouseSelectItemProps): React.JSX.Element {
  return (
    <div className={styles['container']}>
      <div className={styles['main']}>
        <div className={styles['title']}>
          <ArticleParagraph1>{title}</ArticleParagraph1>
          <div className={styles['labels']}>
            {isReliable && <IconProductTrust16 color="icon-main-default" />}
            {hasProblems && <IconProductWarning16 color="icon-negative-default" />}
            {isEscrow && <IconProductEscrou16 color="icon-main-default" />}
            {isSalesStart && <IconProductSalesStart16 color="icon-negative-default" />}
          </div>
        </div>
        {subtitle && <ArticleParagraph3 color="black_60">{subtitle}</ArticleParagraph3>}
      </div>
      <div className={styles['aside']}>
        {value ? <UIText1 color="text-main-default">{value}</UIText1> : <UIText1 color="gray60_100">–</UIText1>}
      </div>
    </div>
  );
}
